export interface HeroPhoneSlide {
  src: string;
  alt: string;
  transition: "push" | "carousel" | "fade" | "select";
  tapX?: string;
  tapY?: string;
  swipeY?: string;
}

export const HERO_PHONE_DASHBOARD_OVERLAY = "/assets/home-phone/dashboard-overlay.png";

export const HERO_PHONE_SLIDES: HeroPhoneSlide[] = [
  {
    "src": "/assets/home-phone/slide-01.png",
    "alt": "Select Business Type",
    "transition": "select",
    "tapX": "50",
    "tapY": "58"
  },
  {
    "src": "/assets/home-phone/slide-02.png",
    "alt": "Select Business Type (S-Corp selected)",
    "transition": "push",
    "tapX": "50",
    "tapY": "93"
  },
  {
    "src": "/assets/home-phone/slide-03.png",
    "alt": "Selected Business Type",
    "transition": "push",
    "tapX": "50",
    "tapY": "93"
  },
  {
    "src": "/assets/home-phone/slide-04.png",
    "alt": "Setup household",
    "transition": "push",
    "tapX": "50",
    "tapY": "93"
  },
  {
    "src": "/assets/home-phone/slide-05.png",
    "alt": "Setup household filled",
    "transition": "push",
    "tapX": "50",
    "tapY": "93"
  },
  {
    "src": "/assets/home-phone/slide-06.png",
    "alt": "W2 Empty",
    "transition": "push",
    "tapX": "50",
    "tapY": "93"
  },
  {
    "src": "/assets/home-phone/slide-07.png",
    "alt": "W2 Filled",
    "transition": "push",
    "tapX": "50",
    "tapY": "93"
  },
  {
    "src": "/assets/home-phone/slide-08.png",
    "alt": "Linked Accounts",
    "transition": "push",
    "tapX": "50",
    "tapY": "93"
  },
  {
    "src": "/assets/home-phone/slide-09.png",
    "alt": "Dashboard (Welcome)",
    "transition": "carousel",
    "swipeY": "30"
  },
  {
    "src": "/assets/home-phone/slide-10.png",
    "alt": "Dashboard (Complete Questionnaire card)",
    "transition": "carousel",
    "swipeY": "30"
  },
  {
    "src": "/assets/home-phone/slide-11.png",
    "alt": "Dashboard (View tax tasks card)",
    "transition": "push",
    "tapX": "50",
    "tapY": "40"
  },
  {
    "src": "/assets/home-phone/slide-12.png",
    "alt": "2025 Taxes",
    "transition": "fade",
    "tapX": "12",
    "tapY": "17"
  }
];
